import { Component, OnInit } from '@angular/core';

@Component({
	selector: 'app-customize',
	templateUrl: './customize.component.html',
	styleUrls: ['./customize.component.css']
})
export class CustomizeComponent implements OnInit {

	constructor() { }

	ngOnInit(): void {
	}

}
